/* eslint no-param-reassign: "off" */

import ElementUpdater from './elementUpdater'
import Selector from './selector'

const updateSingleMoment = (styles) => {
  const { backgroundColor, bodyFontSize, titleFontSize, contentCardColor } =
    styles

  const presentationSlide = '.presentation_slide.single_moment_slide'
  const presentationSlideWrapperSelector =
    '.presentation_slide.single_moment_slide .presentation_slide_wrapper'
  const presentationSlideSubWrapperSelector =
    '.presentation_slide.single_moment_slide .slide_wrapper'
  const presentationSlideContentSelector =
    '.presentation_slide.single_moment_slide ' +
    '.presentation_slide_content:not(.center_content)'
  const singleMomentBackgroundImageSelector =
    '.presentation_slide.single_moment_slide .slide_background_image_wrapper'
  const slideTitleSelector =
    '.presentation_slide.single_moment_slide .slide_title'
  const slideDescriptionSelector =
    '.presentation_slide.single_moment_slide .slide_description'
  const slideMetatdataSelector =
    '.presentation_slide.single_moment_slide .metadata'
  const darkAttributeSelector = '[class*="--dark"]'

  const selectors = [
    new Selector({
      selection: presentationSlide,
      required: true,
    }),
    new Selector({
      selection: presentationSlideWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: presentationSlideSubWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: singleMomentBackgroundImageSelector,
      required: true,
    }),
    new Selector({
      selection: slideTitleSelector,
      required: true,
    }),
    new Selector({
      selection: slideDescriptionSelector,
      required: true,
    }),
    new Selector({
      selection: presentationSlideContentSelector,
      required: false,
    }),
    new Selector({
      selection: slideMetatdataSelector,
      required: true,
    }),
    new Selector({
      selection: darkAttributeSelector,
      required: true,
    }),
  ]

  const updateStyles = () => {
    document.querySelectorAll(presentationSlide).forEach((element) => {
      element.style['background-color'] = backgroundColor
    })

    document
      .querySelectorAll(presentationSlideWrapperSelector)
      .forEach((element) => {
        element.style.position = 'relative'
      })

    document
      .querySelectorAll(presentationSlideSubWrapperSelector)
      .forEach((element) => {
        element.style['margin-top'] = '50px!important'
      })

    document
      .querySelectorAll(singleMomentBackgroundImageSelector)
      .forEach((element) => {
        element.style.top = '0'
      })

    document.querySelectorAll(slideTitleSelector).forEach((element) => {
      element.style.paddingBottom = '25px'
      element.style['font-size'] = titleFontSize
    })

    document.querySelectorAll(slideDescriptionSelector).forEach((element) => {
      const descriptionMinHeight = parseInt(bodyFontSize, 10) * 1.3
      element.style.minHeight = `${descriptionMinHeight}px`
      element.style['font-size'] = bodyFontSize
      element.style.padding = '0px'
    })

    if (contentCardColor === 'light') {
      document.querySelectorAll(darkAttributeSelector).forEach((element) => {
        Array.from(element.classList).forEach((listItem) => {
          if (listItem.includes('--dark')) {
            const darkClassName = listItem
            const lightClassName = listItem.replace('--dark', '--light')

            element.classList.remove(darkClassName)
            element.classList.add(lightClassName)
          }
        })
      })
    }
  }

  const updater = new ElementUpdater(selectors, updateStyles)
  updater.update()
}

export default updateSingleMoment
